import { render, staticRenderFns } from "./QrokantInfo.vue?vue&type=template&id=621cd4bc&"
import script from "./QrokantInfo.vue?vue&type=script&lang=js&"
export * from "./QrokantInfo.vue?vue&type=script&lang=js&"
import style0 from "./QrokantInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports